import {
  GridViewImageGallery,
  ViewPortSizes,
  type GridviewImagePropTypes,
  type NextgenImageProps,
} from '@nextgen-web-framework/all';
import { FC } from 'react';

interface GridViewImagePropsType
  extends GridviewImagePropTypes,
    Omit<NextgenImageProps, 'src' | 'alt' | 'onClick' | 'height' | 'width'> {}

const GridViewGalleryContainer: FC<GridViewImagePropsType> = ({ images, imagesPerRow }: GridViewImagePropsType) => {
  const customProps: GridViewImagePropsType = {
    images,
    imagesPerRow,
    imageWidths: {
      small: 350,
      medium: Math.floor(ViewPortSizes.LARGE / +imagesPerRow),
      large: Math.floor(ViewPortSizes.XLARGE / +imagesPerRow),
      xlarge: Math.floor(ViewPortSizes.XLARGE / +imagesPerRow),
    },
  };
  return <GridViewImageGallery {...customProps} />;
};

export default GridViewGalleryContainer;
